import { useTranslation } from "react-i18next";
import { ACTION_STATUS } from "constants/actions";
import FormDateRangeInput from "form/FormDateRangeInput";
import { ACTION_VIEW_MODE } from "constants/action-form";
import DetailSection from "../../details/DetailSection";

const SuggestedDateSpan = ({ viewMode, status }) => {
  const { t } = useTranslation();

  const shouldInputsInViewMode =
    viewMode === ACTION_VIEW_MODE.view ||
    (viewMode === ACTION_VIEW_MODE.edit && status === ACTION_STATUS.performed);

  return (
    <DetailSection
      title={t("ActionModal.AssignedDate")}
      isRequired={viewMode !== ACTION_VIEW_MODE.view}
    >
      <FormDateRangeInput
        name="dateRange"
        placeholder={t("Components.DateField.Range")}
        isDisabled={shouldInputsInViewMode}
        isViewMode={shouldInputsInViewMode}
        shouldHaveErrorBehaviorAfterSubmit
        formatValue="YYYY-MM-DD"
      />
    </DetailSection>
  );
};

export default SuggestedDateSpan;
